<template>
  <nav class="breadcrumb-nav" aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item small active small" aria-current="page"
          v-for="(crumb, index) in this.$breadcrumbs.value" :key="index">
        <a v-show="!crumb.current" class="link-primary" :href="crumb.link">
          {{ crumb.label }}
        </a>
        <span v-show="crumb.current">
          {{ crumb.label }}
        </span>
      </li>
    </ol>
  </nav>
</template>

<script>
export default {
  name: "Breadcrumb",
}
</script>

<style scoped>

</style>